<template>
  <div class="page">
    <div class="seiten-kopf">
      <router-link to="/einkaufsliste/zutaten-anzeigen" class="seiten-kopf-zurueck" aria-label="Zurück">
        <font-awesome-icon icon="fa-solid fa-arrow-left" />
      </router-link>
      <h1>Zutat bearbeiten</h1>
    </div>

    <form class="zutat-form" @submit.prevent>
      <label for="bearbeiten-zutat-name">Zutat</label>
      <div class="input-field">
        <input id="bearbeiten-zutat-name" v-model="Bearbeiten.Name" type="text" placeholder="Zutat" />
      </div>

      <label for="bearbeiten-zutat-menge">Menge</label>
      <div class="input-field">
        <input id="bearbeiten-zutat-menge" v-model.number="Bearbeiten.Menge" type="number" min="0" step="any" placeholder="Menge" />
      </div>

      <label for="bearbeiten-zutat-einheit">Einheit</label>
      <div class="input-field">
        <select id="bearbeiten-zutat-einheit" v-model="Bearbeiten.Einheit">
          <option value="Gramm">Gramm</option>
          <option value="Kg">Kg</option>
          <option value="ml">ml</option>
          <option value="Liter">Liter</option>
          <option value="Volumen">Volumen</option>
          <option value="Stück">Stück</option>
          <option value="Flasche">Flasche</option>
          <option value="Packung">Packung</option>
          <option value="EL">EL</option>
          <option value="Netz">Netz</option>
        </select>
      </div>

      <label for="bearbeiten-zutat-kategorie">Kategorie</label>
      <div class="input-field">
        <select id="bearbeiten-zutat-kategorie" v-model="Bearbeiten.KategorieId">
          <option v-for="Kategorie in Kategorien" :key="Kategorie.Id" :value="Kategorie.Id">{{ Kategorie.Name }}</option>
        </select>
      </div>

      <label class="filter-toggle-zeile">
        <input v-model="Bearbeiten.Eingefroren" type="checkbox" />
        🧊 Diese Zutat ist eingefroren
      </label>

      <label>Foto</label>
      <BildAuswahl v-model="Bild" :bestehend-url="BestehendesBildUrl" />

      <p v-if="Status" class="hint-message success">{{ Status }}</p>
      <p v-if="Fehlermeldung" class="error-message">{{ Fehlermeldung }}</p>

      <div class="button-row">
        <button type="button" class="btn btn-primary" @click="Speichern">Speichern</button>
        <router-link to="/einkaufsliste/zutaten-anzeigen" class="btn btn-secondary">Abbrechen</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { ZutatFinden, ZutatenLaden, ZutatAktualisieren, ZutatBildSpeichern, Kategorien, KategorienLaden } from '../composables/useZutaten'
import { BildUrl } from '../composables/useBilder'
import BildAuswahl from '../components/BildAuswahl.vue'

export default {
  name: 'ZutatenBearbeitenView',
  components: { BildAuswahl },
  data() {
    return {
      Kategorien,
      ZutatId: null,
      Original: { Name: '', Menge: null, Einheit: 'Gramm', KategorieId: null, Eingefroren: false },
      Bearbeiten: { Name: '', Menge: null, Einheit: 'Gramm', KategorieId: null, Eingefroren: false },
      Bild: undefined,
      Status: '',
      Fehlermeldung: ''
    }
  },
  computed: {
    BestehendesBildUrl() {
      const Zutat = ZutatFinden(this.ZutatId)
      return Zutat && Zutat.HatBild ? BildUrl('Zutat', Zutat.Id, Zutat.BildVersion) : null
    }
  },
  async created() {
    await Promise.all([KategorienLaden(), ZutatenLaden()])
    this.ZutatId = Number(this.$route.params.id)
    const Zutat = ZutatFinden(this.ZutatId)
    if (Zutat) {
      this.Original = { Name: Zutat.Name, Menge: Zutat.Menge, Einheit: Zutat.Einheit, KategorieId: Zutat.KategorieId, Eingefroren: !!Zutat.Eingefroren }
      this.Bearbeiten = { ...this.Original }
    }
  },
  methods: {
    async Speichern() {
      this.Fehlermeldung = ''
      const Aenderungen = {}
      if (this.Bearbeiten.Name !== this.Original.Name) {
        Aenderungen.Name = this.Bearbeiten.Name
      }
      if (this.Bearbeiten.Menge !== this.Original.Menge) {
        Aenderungen.Menge = this.Bearbeiten.Menge
      }
      if (this.Bearbeiten.Einheit !== this.Original.Einheit) {
        Aenderungen.Einheit = this.Bearbeiten.Einheit
      }
      if (this.Bearbeiten.KategorieId !== this.Original.KategorieId) {
        Aenderungen.KategorieId = this.Bearbeiten.KategorieId
      }
      if (this.Bearbeiten.Eingefroren !== this.Original.Eingefroren) {
        Aenderungen.Eingefroren = this.Bearbeiten.Eingefroren
      }

      const BildGeaendert = this.Bild !== undefined
      if (Object.keys(Aenderungen).length === 0 && !BildGeaendert) {
        this.Status = 'Keine Änderungen.'
        return
      }

      try {
        if (Object.keys(Aenderungen).length > 0) {
          await ZutatAktualisieren(this.ZutatId, Aenderungen)
        }
        if (BildGeaendert) {
          await ZutatBildSpeichern(this.ZutatId, this.Bild)
        }
        this.$router.push('/einkaufsliste/zutaten-anzeigen')
      } catch (Fehler) {
        this.Fehlermeldung = Fehler.message
      }
    }
  }
}
</script>

<style scoped>
.zutat-form {
  display: flex;
  flex-direction: column;
  max-width: 320px;
  margin-top: 16px;
}

.zutat-form label {
  margin-top: 12px;
  margin-bottom: 4px;
  font-size: 0.9rem;
}
</style>
